import {format, support} from "../i18n";

// What a support ticket message can carry: the API's rules (tristar-corp-api SupportAttachments.ts), checked here first
// so the form can say what's wrong. The API checks the files' contents again, and refuses scripts saved as .txt.

export const SUPPORT_FILE_MAX_BYTES = 10 * 1024 * 1024;
export const SUPPORT_FILES_PER_MESSAGE = 5;

// By extension, since browsers don't always know a file's type (Windows often leaves .txt, .log and others blank).
const TYPES: Record<string, string> = {
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    txt: 'text/plain'
};

// For the file input's accept attribute.
export const SUPPORT_FILE_ACCEPT = '.png,.jpg,.jpeg,.txt,image/png,image/jpeg,text/plain';

export function supportFileType(fileName: string): string | undefined {
    const dot = fileName.lastIndexOf('.');
    return dot >= 0 ? TYPES[fileName.substring(dot + 1).toLowerCase()] : undefined;
}

// Why the file can't be attached, or undefined when it can.
export function supportFileProblem(file: { name: string, size: number }): string | undefined {
    if (!supportFileType(file.name)) {
        return format(support.attachments.wrongType, { name: file.name });
    }
    if (file.size === 0) {
        return format(support.attachments.empty, { name: file.name });
    }
    if (file.size > SUPPORT_FILE_MAX_BYTES) {
        return format(support.attachments.tooLarge, { name: file.name });
    }
    return undefined;
}

// The files to keep after adding some to those already chosen, and why any were left out. Files whose name and size
// match one already chosen are skipped as duplicates.
export function addSupportFiles(current: File[], added: File[]): { files: File[], problems: string[] } {
    const files = [...current];
    const problems: string[] = [];
    for (const file of added) {
        const problem = supportFileProblem(file);
        if (problem) {
            problems.push(problem);
        } else if (files.some(x => x.name === file.name && x.size === file.size)) {
            continue;
        } else if (files.length >= SUPPORT_FILES_PER_MESSAGE) {
            problems.push(format(support.attachments.tooMany, { max: SUPPORT_FILES_PER_MESSAGE, name: file.name }));
        } else {
            // The upload has to declare the type the API expects for the extension, whatever the browser thought.
            files.push(file.type === supportFileType(file.name) ? file : new File([file], file.name, { type: supportFileType(file.name) }));
        }
    }
    return { files, problems };
}
